/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to revert a feature bundle to a previous revision. Optionally run sync so tenant entitlements follow per bundle_sync_policy.
 * @export
 * @interface RevertToRevisionRequest
 */
export interface RevertToRevisionRequest {
    /**
     * Revision record ID to restore (from GET .../revisions)
     * @type {string}
     * @memberof RevertToRevisionRequest
     */
    revisionId: string;
    /**
     * If true, after restoring the bundle definition run sync so existing tenant grants are updated per bundle_sync_policy (SYNC_TO_BUNDLE / GRANDFATHER). Default true.
     * @type {boolean}
     * @memberof RevertToRevisionRequest
     */
    runSync?: boolean;
}

/**
 * Check if a given object implements the RevertToRevisionRequest interface.
 */
export function instanceOfRevertToRevisionRequest(value: object): value is RevertToRevisionRequest {
    if (!('revisionId' in value) || value['revisionId'] === undefined) return false;
    return true;
}

export function RevertToRevisionRequestFromJSON(json: any): RevertToRevisionRequest {
    return RevertToRevisionRequestFromJSONTyped(json, false);
}

export function RevertToRevisionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevertToRevisionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'revisionId': json['revisionId'],
        'runSync': json['runSync'] == null ? undefined : json['runSync'],
    };
}

export function RevertToRevisionRequestToJSON(json: any): RevertToRevisionRequest {
    return RevertToRevisionRequestToJSONTyped(json, false);
}

export function RevertToRevisionRequestToJSONTyped(value?: RevertToRevisionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'revisionId': value['revisionId'],
        'runSync': value['runSync'],
    };
}

